// Dev-only logger. In production builds, calls become no-ops.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
};
